import { isValidPhoneNumber as isValid } from 'libphonenumber-js'
import { MoovyConstantNames } from './globalNames'
import isEmail from 'validator/lib/isEmail'

export namespace MoovyFormRestrictions {
  export const INPUT_MAX_CHARS = 255
}

export const isValidPhoneNumberOrEmptyOrPlaceholder = (
  phoneNumber?: string
): boolean => {
  if (
    !phoneNumber?.trim() ||
    phoneNumber === MoovyConstantNames.PHONE_FI_COUNTRY_CODE
  )
    return true

  return isValid(phoneNumber)
}

export const isValidLicensePlate = (licensePlateNumber?: string): boolean => {
  const pattern = /^[A-ZÅÄÖa-zåäö0-9\\s-]{2,10}$/
  return !!licensePlateNumber && pattern.test(licensePlateNumber)
}

export const isValidEmail = (email?: string): boolean => {
  if (!email) return false
  return isEmail(email, { allow_utf8_local_part: false })
}
